package com.vamvisions.main.contact.data.repository

import com.vamvisions.main.api.contact.ContactMessageRequestDto
import com.vamvisions.main.contact.data.mapper.toDto
import com.vamvisions.main.contact.data.remote.ContactApi
import com.vamvisions.main.contact.domain.model.ContactMessage
import com.vamvisions.main.contact.domain.repository.ContactRepository
import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.EmptyResult
import com.vamvisions.main.core.domain.asEmptyResult

class RemoteContactRepository(private val api: ContactApi) : ContactRepository {

    override suspend fun send(message: ContactMessage): EmptyResult<DataError.Network> =
        api.send(
            ContactMessageRequestDto(
                name = message.name,
                email = message.email,
                message = message.message,
                topic = message.topic?.toDto(),
                website = message.website,
            ),
        ).asEmptyResult()
}
